module.exports = __webpack_public_path__ + "upload-image-hover.svg?44fb1881ca7b08b0aaa8b4ca04caf892";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upload-image-hover.svg
// module id = 189
// module chunks = 0